import { callUIAPI } from './apiUtils';
import { handleUserIsUnauthorized } from './utils';
import * as apiConstants from './apiUtilsConstants';
import * as dbConstants from '../dao/dbConstants';
import { startAndPollJob } from './jobPollingUtils';



export const getAssetLinks = async (assetId) => {
  return callUIAPI(apiConstants.entityAPIRoutes[dbConstants.ENTITY_NAME_ASSET] + `/${assetId}/links`, null, apiConstants.METHOD_GET, true)
    .then(response => {
      console.log('assetApiUtils.getAssetLinks - response:', response);
      return response.data.list || [];
    })
    .catch(error => {
      console.error('assetApiUtils.getAssetLinks - error:', error);
      return handleUserIsUnauthorized(error, []);
    });
};




export const getTestimonialsByAssetId = async (assetId) => {
  console.log('assetApiUtils.getTestimonialsByAssetId - assetId:', assetId);
  return callUIAPI(`asset/${assetId}/testimonials`, null, apiConstants.METHOD_GET, true)
    .then(response => {
      console.log('assetApiUtils.getTestimonialsByAssetId - response:', response);
      return response.data.list || [];
    })
    .catch(error => {
      console.error('assetApiUtils.getTestimonialsByAssetId - error:', error);
      throw error;
    });
};

export const getRecognitionsByAssetId = async (assetId) => {
  return callUIAPI(`asset/${assetId}/recognitions`, null, apiConstants.METHOD_GET, true)
    .then(response => response.data.list || [])
    .catch(error => {
      console.error('assetApiUtils.getRecognitionsByAssetId - error:', error);
      throw error;
    });
};

export const createRecognition = async (assetId, payload) => {
  return callUIAPI(`asset/${assetId}/recognitions`, payload, apiConstants.METHOD_POST, true)
    .then(response => response.data.item)
    .catch(error => {
      console.error('assetApiUtils.createRecognition - error:', error);
      throw error;
    });
};

export const updateRecognition = async (assetId, recognitionId, payload) => {
  return callUIAPI(`asset/${assetId}/recognitions/${recognitionId}`, payload, apiConstants.METHOD_PUT, true)
    .then(response => response.data.item)
    .catch(error => {
      console.error('assetApiUtils.updateRecognition - error:', error);
      throw error;
    });
};

export const deleteRecognition = async (assetId, recognitionId) => {
  return callUIAPI(`asset/${assetId}/recognitions/${recognitionId}`, null, apiConstants.METHOD_DELETE, true)
    .then(response => response.data)
    .catch(error => {
      console.error('assetApiUtils.deleteRecognition - error:', error);
      throw error;
    });
};

export const importRecognitionsFromWebsite = async (assetId, url) => {
  return callUIAPI(`asset/${assetId}/recognitions/import`, { url }, apiConstants.METHOD_POST, true)
    .then(response => response.data.item || response.item)
    .catch(error => {
      console.error('assetApiUtils.importRecognitionsFromWebsite - error:', error);
      throw error;
    });
};

export const discoverRecognitions = async (assetId, { companyName, website }) => {
  return callUIAPI(`asset/${assetId}/recognitions/discover`, { companyName, website }, apiConstants.METHOD_POST, true)
    .then(response => response.data.candidates || [])
    .catch(error => {
      console.error('assetApiUtils.discoverRecognitions - error:', error);
      throw error;
    });
};

/**
 * Import testimonials from TripAdvisor asynchronously using background job polling.
 * Use this when the backend endpoint returns { jobId } instead of the result directly.
 * The backend status endpoint is expected at: asset/status/<jobId>
 *
 * @param {number}   assetId      - The asset ID to associate testimonials with
 * @param {object}   locationData - TripAdvisor location data from modal
 * @param {Function} [onProgress] - Called with each new log event: { message, details? }
 * @returns {Promise<{ data: any }>} - Resolves with { data: result } on completion
 *
 * Component usage (mirrors SEO.jsx pattern):
 *   // In state:  progressLog: [], isLoading: false
 *   // Callback:  addProgressLog(event) { this.setState(prev => ({ progressLog: [...prev.progressLog, event] })); }
 *   //
 *   // Before call:
 *   //   this.setState({ isLoading: true, progressLog: [{ message: 'Importing testimonials...' }] });
 *   // Call:
 *   //   const result = await importTripAdvisorTestimonialsAsync(assetId, locationData, this.addProgressLog);
 *   // After:
 *   //   this.setState({ isLoading: false, progressLog: [] });
 */
export const importTripAdvisorTestimonialsAsync = async (assetId, locationData, onProgress) => {
  console.log('assetApiUtils.importTripAdvisorTestimonialsAsync - assetId:', assetId, ', locationData:', locationData);
  return startAndPollJob(
    `asset/${assetId}/testimonials/tripadvisor/import/async`,
    { locationData },
    'assets/links/import-status',
    onProgress
  );
};

export const importGoogleReviewsAsync = async (assetId, placeData, onProgress) => {
  console.log('assetApiUtils.importGoogleReviewsAsync - assetId:', assetId, ', placeData:', placeData);
  return startAndPollJob(
    `asset/${assetId}/testimonials/google/import/async`,
    { placeData },
    'assets/links/import-status',
    onProgress
  );
};

export const deleteTestimonial = async (assetId, testimonialId) => {
  console.log('assetApiUtils.deleteTestimonial - assetId:', assetId, ', testimonialId:', testimonialId);
  return callUIAPI(`asset/${assetId}/testimonials/${testimonialId}`, null, apiConstants.METHOD_DELETE, true)
    .then(response => {
      console.log('assetApiUtils.deleteTestimonial - response:', response);
      return response.data;
    })
    .catch(error => {
      console.error('assetApiUtils.deleteTestimonial - error:', error);
      throw error;
    });
};
